import axios from 'axios'

const api = axios.create({
  baseURL: window.location.hostname === 'localhost' ? 'http://localhost/apimerenda' : '/apimerenda',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    console.log(token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
        console.log(error);
        return;
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      try {
        const storedUser = localStorage.getItem('user')
        const parsedUser = storedUser ? JSON.parse(storedUser) : null
        const isAdmin = parsedUser?.tipo && parsedUser.tipo !== 'produtor'
        window.location.href = isAdmin ? '/admin/login' : '/login'
      } catch {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api

